import { ContentTemplateModel, ContentType } from "outbound-api-client/lib/models";
import { apiService } from "../../services";

export const getContentTemplate = async (identifier: string, campaignIdentifier: string | null = null): Promise<ContentTemplateModel> => {
  return apiService.instance.getContentTemplateByIdentifier(identifier, campaignIdentifier);
}

export const getContentTemplates = async (contentType: ContentType | null, campaignIdentifier: string | null = null): Promise<Array<ContentTemplateModel>> => {
  return apiService.instance.getContentTemplates(contentType, campaignIdentifier);
}